define('controller/disclosure/disclosure.documents.tab.controller',['require','exports','module','controller/disclosure/disclosure.tab.controller','model/disclosure.detail.model','model/review.person.model','model/person.model','model/user.model','model/outcome.model','fukit','model/disclosure.comment.model','model/previous.reviewer.model','model/disclosure.documents.model','model/settings.model','view/disclosure/disclosure.documents.tab.page.view'],function (require, exports, module) {
    //prettier-ignore
    var DisclosureTabController       = require('controller/disclosure/disclosure.tab.controller'),

        DisclosureDetailModel         = require('model/disclosure.detail.model'),
        ReviewerPersonModel           = require('model/review.person.model'),
        PersonModel                   = require('model/person.model'),
        UserModel                     = require('model/user.model'),
        OutcomeModel                  = require('model/outcome.model'),
        ResourceQueryCollection       = require('fukit').ResourceQueryCollection,
        DisclosureCommentModel        = require('model/disclosure.comment.model'),
        PreviousReviewerModel         = require('model/previous.reviewer.model'),
        DocumentsModel                = require('model/disclosure.documents.model'),
        SettingsModel                 = require('model/settings.model'),

        DisclosureDocumentTabPageView = require('view/disclosure/disclosure.documents.tab.page.view');

    var DisclosureDocumentsTabController = DisclosureTabController.extend({
        radioRequests: {
            'controllers DisclosureDocumentsTabController': '@constructor',
        },

        pageView: DisclosureDocumentTabPageView,

        //------------
        resources: {

            //------------------- Disclosure related models
            disclosure: {
                fetchOnStart: true,
                model: DisclosureDetailModel,
                attrs: {
                    id: '@state.primaryId',
                },
            },
            disclosureAssignmentDetailModel: {
                resourcePath: '@resources.disclosure.assignmentDetailModel',
            },

            //Workflow related models and collections
            workflowActivityStateModel: {
                model: Backbone.Model,
            },
            workflowTaskModel: {
                required: false,
                resourcePath: '@resources.disclosure.workflowTaskModel',
            },
            availableReviewersCollection: {
                fetchOnStart: true,
                resourceOptions:{
                    paginate: {
                        size: 1000
                    }
                },
                collection: ReviewerPersonModel.Collection,
            },
            settingsModel: {
              model: SettingsModel,
              fetchOnStart: true,
              fetchWhenNew: true
            },

            //models and collections needed for modals linked from my tasks
            sessionDecisionModel: {
                required: false,
                fetchOnStart: true,
                resourcePath: '@resources.disclosure.sessionDecisionModel',
            },
            outcomeCollection: {
                collection: OutcomeModel.Collection,
                required: false,
                sort: {
                    field: 'description',
                    direction: 'ascending',
                },
            },

            disclosureCommentModel: {
                model: DisclosureCommentModel,
            },

            previousReviewerModel: {
                required: false,
                model: PreviousReviewerModel,
            },

            //------------------- resources specific for Documents tab

            documentsCollection: {
                collection: DocumentsModel.Collection,
                required: false,
            },

            DocumentTypeCollection: {

                model: Backbone.Collection,
                collection: Backbone.Collection,
                data: [
                    {value: 'COI Management Plan'},
                    {value: 'Correspondence'},
                    {value: '700U Form (California Only)'},
                    {value: 'Other'}
                ],
            },

        },

        onStart: function () {

            this.listenTo(this.getResource('disclosure'), 'sync', function (disclosureDetailModel) {

                var id = disclosureDetailModel.get('id');

                var documentsCollection = this.getResource('documentsCollection');

                documentsCollection.filters.addFilterWithField(
                    {name: 'attachmentPoint'}).equals(id);

                documentsCollection
                    .fetch()
                    .promise()
                    .bind(this)
                    .catch(function(error) {
                        console.error('An error occurred while fetching documents:', error);
                });

                var outcomeCollection = this.getResource('outcomeCollection');

                if (disclosureDetailModel.get('templateTypeDescription')) {
                    outcomeCollection.urlParams({
                        templateType: disclosureDetailModel.get('templateTypeDescription'),
                    });
                    outcomeCollection.fetch();
                }

            });

        },
        //--------------


    });

    module.exports = DisclosureDocumentsTabController;
});

